import React from 'react';
import { componentName } from '../utils/componentName';

// Детализация состава букета/сета для quick-view: строки «имя ×N ····· цена»,
// затем База и Сервисный сбор. detail — ответ api.getBouquet (components,
// components_total, service_fee, service_fee_percent). Используется в каталоге
// (BouquetCard) и в корзине (CartPage) — правки делать здесь, чтобы не разъехались.
function BouquetCompositionDetail({ detail, title }) {
  if (!detail?.components?.length) return null;
  return (
    <div style={{ marginBottom: 10, fontSize: 13, lineHeight: 1.7 }}>
      <div style={{ fontWeight: 600, marginBottom: 4, color: 'var(--text-secondary)' }}>
        {title}:
      </div>
      {/* Grid: колонки ×N/точка/цена сжимаются под самое широкое значение —
          количество стоит вплотную к цене, при этом все строки выровнены */}
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) auto auto auto', columnGap: 6, alignItems: 'baseline' }}>
        {detail.components.map(c => {
          // line_total с бэка уже учитывает custom-цену букета;
          // фолбэк — количество × текущая цена стебля
          const lineTotal = c.line_total != null
            ? c.line_total
            : (c.product_price || 0) * c.quantity;
          return (
            <React.Fragment key={c.id}>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {componentName(c)}
              </span>
              <span style={{ color: 'var(--text-secondary)', textAlign: 'right', whiteSpace: 'nowrap' }}>×{c.quantity}</span>
              <span style={{ color: 'var(--text-secondary)' }}>·</span>
              <span style={{ textAlign: 'right', whiteSpace: 'nowrap', fontWeight: 500 }}>
                {Math.round(lineTotal).toLocaleString('ru-RU')}₽
              </span>
            </React.Fragment>
          );
        })}
      </div>
      <div style={{ borderTop: '1px solid var(--border-color)', marginTop: 6, paddingTop: 6, color: 'var(--text-secondary)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>База</span>
          <span style={{ fontWeight: 500 }}>{Math.round(detail.components_total || 0).toLocaleString('ru-RU')}₽</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Сервисный сбор{detail.service_fee_percent ? ` (${Math.round(detail.service_fee_percent)}%)` : ''}</span>
          <span style={{ fontWeight: 500 }}>{Math.round(detail.service_fee || 0).toLocaleString('ru-RU')}₽</span>
        </div>
      </div>
    </div>
  );
}

export default BouquetCompositionDetail;
